/**
 * ADR-024 : les deux organisations portées par le jeton.
 * - `organizationId` : l'org dont l'utilisateur LIT les données (`org_id`) — sites, trackers…
 * - `tenantOrganizationId` : l'org qui le POSSÈDE (`tenant_org_id`) — équipe, clés API, audit.
 * Égales pour une org ordinaire ; pour une org de démo, `org_id` est l'org source des données
 * partagées et `tenant_org_id` l'org du prospect.
 */
export function resolveOrganizationIds(
  claims: Record<string, unknown>,
  legacyCustomerId?: string
): { organizationId: string; tenantOrganizationId: string } {
  const organizationId = (claims['org_id'] as string | undefined) ?? legacyCustomerId ?? '';
  const tenantOrganizationId = (claims['tenant_org_id'] as string | undefined) || organizationId;
  return { organizationId, tenantOrganizationId };
}
